// extracted by css-extract-rspack-plugin
export default {"ControlGroupFix":"ContrastSetting-module__ControlGroupFix__HMIwn"};